import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';
import { LANGUAGE_CODES, DEFAULT_LANGUAGE } from './languages';
import { useAppStore } from '@/shared/lib/store/useAppStore';

const savedLanguage = useAppStore.getState().language || DEFAULT_LANGUAGE;

i18n
  .use(HttpBackend)
  .use(initReactI18next)
  .init({
    lng: savedLanguage,
    fallbackLng: DEFAULT_LANGUAGE,
    supportedLngs: LANGUAGE_CODES,
    interpolation: {
      escapeValue: false,
    },
    backend: {
      loadPath: '/locales/{{lng}}/translation.json',
    },
  });

export { i18n };
